/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Responsable', Responsable);

    /* @ngInject */
    function Responsable($resource) {
        return $resource('api/admin/responsable/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/responsable/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/responsable/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/responsable/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/responsable/findUsedLetters'
            },
            'simpleFilter': {
                method: 'GET',
                isArray: false,
                url: 'api/public/responsable/simpleFilter'
            },
            'canonicoFilter': {
                method: 'GET',
                isArray: false,
                url: 'api/public/responsable/canonicoFilter'
            },
            'setRevisado': {
                method: 'POST',
                isArray: false,
                url: 'api/admin/responsable/setRevisado'
            }
        });
    }
})();
